/* Purova v2 interactions */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* reveal on scroll */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-pv-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* hero switcher */
  function initHero(root) {
    (root || document).querySelectorAll('[data-pv-hero]').forEach(function (hero) {
      if (hero.dataset.ready) return; hero.dataset.ready = 1;
      var btns = hero.querySelectorAll('[data-pv-hero-btn]');
      var panes = hero.querySelectorAll('[data-pv-hero-pane]');
      var imgs = hero.querySelectorAll('[data-pv-hero-img]');
      var dots = hero.querySelectorAll('[data-pv-hero-dot]');
      var dur = parseInt(hero.dataset.interval || '6', 10) * 1000;
      var i = 0, timer = null;
      hero.style.setProperty('--pv-dur', dur / 1000 + 's');
      function show(n) {
        i = n;
        btns.forEach(function (b, k) { b.setAttribute('aria-selected', k === n ? 'true' : 'false'); });
        [panes, imgs, dots].forEach(function (list) { list.forEach(function (el, k) { el.classList.toggle('is-active', k === n); }); });
        var b = btns[n];
        if (b) { hero.style.setProperty('--tint', b.dataset.tint); hero.style.setProperty('--tint2', b.dataset.tint2); hero.style.setProperty('--pv-accent', b.dataset.accent); }
        // restart dot animation
        dots.forEach(function (d) { d.classList.remove('is-active'); void d.offsetWidth; });
        if (dots[n]) dots[n].classList.add('is-active');
      }
      function next() { show((i + 1) % btns.length); }
      function start() { if (reduce || btns.length < 2) return; stop(); timer = setInterval(next, dur); }
      function stop() { if (timer) clearInterval(timer); timer = null; }
      btns.forEach(function (b, k) { b.addEventListener('click', function () { show(k); hero.classList.add('is-paused'); stop(); }); });
      hero.addEventListener('mouseenter', stop); hero.addEventListener('mouseleave', function () { if (!hero.classList.contains('is-paused')) start(); });
      show(0); start();
    });
  }

  /* generic tabs: [data-pv-tabs] with [data-pv-tab] buttons and [data-pv-panel] */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-pv-tabs]').forEach(function (wrap) {
      if (wrap.dataset.ready) return; wrap.dataset.ready = 1;
      var btns = wrap.querySelectorAll('[data-pv-tab]'), panels = wrap.querySelectorAll('[data-pv-panel]');
      btns.forEach(function (b, k) {
        b.addEventListener('click', function () {
          btns.forEach(function (x, j) { x.setAttribute('aria-selected', j === k ? 'true' : 'false'); });
          panels.forEach(function (p, j) { p.classList.toggle('is-active', j === k); });
          if (b.dataset.tint) { wrap.style.setProperty('--pv-tintc', b.dataset.tint); }
        });
      });
    });
  }

  /* finder */
  function initFinder(root) {
    (root || document).querySelectorAll('[data-pv-finder]').forEach(function (f) {
      if (f.dataset.ready) return; f.dataset.ready = 1;
      var picks = f.querySelectorAll('[data-pv-pick]');
      var res = {}; f.querySelectorAll('[data-pv-res]').forEach(function (r) { res[r.dataset.pvRes] = r; });
      function update() {
        var c = 0, a = 0;
        picks.forEach(function (p) { if (p.getAttribute('aria-pressed') === 'true') { if (p.dataset.pvPick === 'amber') a++; else c++; } });
        var key = (c === 0 && a === 0) ? 'empty' : (a === 0 ? 'classic' : (c === 0 ? 'amber' : 'both'));
        Object.keys(res).forEach(function (k) { res[k].classList.toggle('is-active', k === key); res[k].setAttribute('aria-hidden', k === key ? 'false' : 'true'); });
      }
      picks.forEach(function (p) { p.addEventListener('click', function () { p.setAttribute('aria-pressed', p.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); update(); }); });
      update();
    });
  }

  /* sugar calculator */
  function animateNum(el, to, dec) {
    var from = parseFloat(el.dataset.v || '0'); el.dataset.v = to;
    if (reduce) { el.textContent = to.toFixed(dec); return; }
    var t0 = null, d = 450;
    function step(ts) { if (!t0) t0 = ts; var k = Math.min(1, (ts - t0) / d); k = 1 - Math.pow(1 - k, 3); el.textContent = (from + (to - from) * k).toFixed(dec); if (k < 1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  function initCalc(root) {
    (root || document).querySelectorAll('[data-pv-calc]').forEach(function (c) {
      if (c.dataset.ready) return; c.dataset.ready = 1;
      var cups = c.querySelector('[data-pv-cups]'), tsp = c.querySelector('[data-pv-tsp]');
      var gPerTsp = parseFloat(c.dataset.gpertsp || '4'), limit = parseFloat(c.dataset.limit || '25');
      function fill(r) { var p = (r.value - r.min) / (r.max - r.min) * 100; r.style.setProperty('--p', p + '%'); }
      function update() {
        fill(cups); fill(tsp);
        c.querySelector('[data-pv-out-cups]').textContent = cups.value;
        c.querySelector('[data-pv-out-tsp]').textContent = tsp.value;
        var t = cups.value * tsp.value, g = t * gPerTsp, kcal = g * 4, yr = g * 365 / 1000;
        animateNum(c.querySelector('[data-pv-g]'), g, 0);
        animateNum(c.querySelector('[data-pv-kcal]'), kcal, 0);
        animateNum(c.querySelector('[data-pv-yr]'), yr, 1);
        var pct = Math.round(g / limit * 100);
        var max = Math.max(limit * 2, g);
        c.querySelector('[data-pv-fill]').style.width = Math.min(100, g / max * 100) + '%';
        c.querySelector('[data-pv-mark]').style.setProperty('--m', (limit / max * 100) + '%');
        var msg = c.querySelector('[data-pv-msg]');
        if (g === 0) msg.innerHTML = 'No sugar in your cups. <b>Nice.</b>';
        else msg.innerHTML = 'That’s <b>' + pct + '%</b> of WHO’s ideal daily limit of ' + limit + ' g of free sugars, from your cups alone.';
      }
      cups.addEventListener('input', update); tsp.addEventListener('input', update); update();
    });
  }

  /* compare: mobile segment */
  function initCompare(root) {
    (root || document).querySelectorAll('[data-pv-cmp]').forEach(function (c) {
      if (c.dataset.ready) return; c.dataset.ready = 1;
      var table = c.querySelector('.pv-cmp__table'), btns = c.querySelectorAll('[data-pv-cmp-btn]');
      btns.forEach(function (b) { b.addEventListener('click', function () { btns.forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); }); table.dataset.show = b.dataset.pvCmpBtn; }); });
    });
  }

  function initAll(root) { initReveal(root); initHero(root); initTabs(root); initFinder(root); initCalc(root); initCompare(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

/* announcement bar: loop forward continuously (fade through instead of scrolling back) */
(function(){
  function patch(){
    var C=customElements.get('slideshow-component'); if(!C||C.__pvLoop) return; C.__pvLoop=true;
    var orig=C.prototype.autoRotateSlides;
    C.prototype.autoRotateSlides=function(){
      var s=this.slider, bar=this.closest&&this.closest('.utility-bar');
      if(!bar||!s||this.currentPage!==this.sliderItems.length) return orig.call(this);
      s.style.transition='opacity .3s ease'; s.style.opacity='0';
      setTimeout(function(){ s.scrollTo({left:0,behavior:'instant'}); setTimeout(function(){ s.style.opacity='1'; },80); },320);
    };
  }
  if(window.customElements&&customElements.whenDefined) customElements.whenDefined('slideshow-component').then(patch);
})();
